import { lazy } from 'react';
import { HasAccess } from 'modules/auth/components/HasAccess';
import {
  EAccountPermissions,
  EPermission,
} from 'modules/auth/context/permify/permify.interfaces';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';
import { HasProfileAccess } from 'modules/auth/components/HasProfileAccess';

const NaturalPersonListPage = lazy(() =>
  import('../pages/NaturalPersonListPage').then((m) => ({
    default: m.NaturalPersonListPage,
  })),
);
const NaturalPersonHandler = lazy(() =>
  import('../pages/NaturalPersonHandler').then((m) => ({
    default: m.NaturalPersonHandler,
  })),
);
const LegalPersonListPage = lazy(() =>
  import('../pages/LegalPersonListPage').then((m) => ({
    default: m.LegalPersonListPage,
  })),
);
const LegalPersonHandler = lazy(() =>
  import('../pages/LegalPersonHandler').then((m) => ({
    default: m.LegalPersonHandler,
  })),
);
const LegalPersonViewPage = lazy(
  () => import('../pages/LegalPersonViewPage/LegalPersonViewPage'),
);
const LegalPersonViewScrDetails = lazy(() =>
  import('../pages/LegalPersonViewPage/components/LegalPersonViewScrTab').then(
    (m) => ({ default: m.LegalPersonViewScrDetails }),
  ),
);
const NaturalPersonViewPage = lazy(() =>
  import('../pages/NaturalPersonViewPage').then((m) => ({
    default: m.NaturalPersonViewPage,
  })),
);
const NaturalPersonViewScrDetails = lazy(() =>
  import(
    '../pages/NaturalPersonViewPage/components/NaturalPersonViewScrTab'
  ).then((m) => ({ default: m.NaturalPersonViewScrDetails })),
);

const CustomerRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.records.natural,
        element: (
          <HasAccess permission={EPermission.NATURAL_PERSON_LIST}>
            <NaturalPersonListPage />
          </HasAccess>
        ),
      },
      {
        path: routingPath.records.naturalNew,
        element: (
          <HasProfileAccess
            permission={EAccountPermissions.CREATE_PERSON_BUSINESS}
          >
            <NaturalPersonHandler />
          </HasProfileAccess>
        ),
      },
      {
        path: routingPath.records.legal,
        element: (
          <HasAccess permission={EPermission.LEGAL_PERSON_LIST}>
            <LegalPersonListPage />
          </HasAccess>
        ),
      },
      {
        path: routingPath.records.legalNew,
        element: (
          <HasProfileAccess
            permission={EAccountPermissions.CREATE_PERSON_BUSINESS}
          >
            <LegalPersonHandler />
          </HasProfileAccess>
        ),
      },
      {
        path: routingPath.records.legalView,
        element: (
          <HasAccess permission={EPermission.LEGAL_PERSON_VIEW}>
            <LegalPersonViewPage />
          </HasAccess>
        ),
      },
      {
        path: routingPath.records.legalScr,
        element: (
          <HasAccess permission={EPermission.LEGAL_PERSON_VIEW}>
            <LegalPersonViewScrDetails />
          </HasAccess>
        ),
      },
      {
        path: routingPath.records.naturalView,
        element: (
          <HasAccess permission={EPermission.NATURAL_PERSON_VIEW}>
            <NaturalPersonViewPage />
          </HasAccess>
        ),
      },
      {
        path: routingPath.records.naturalScr,
        element: (
          <HasAccess permission={EPermission.NATURAL_PERSON_VIEW}>
            <NaturalPersonViewScrDetails />
          </HasAccess>
        ),
      },
    ],
  };
};

export default CustomerRoutes;
